/**
 * Heaps session access token. Deliberately not called `accessToken` - that name
 * is common enough that a provider or campaign link could append one of its
 * own, and honouring a foreign token would replace the visitor's session.
 */
export const HANDOVER_ACCESS_TOKEN_PARAM = "hsat"

/**
 * Superseded by `hsat`. Still read so that payments already in flight when this
 * shipped complete correctly - safe to delete once none can be outstanding.
 */
const LEGACY_ACCESS_TOKEN_PARAM = "accessToken"

// Only the post-payment redirect issues the handover, and it is the only route
// allowed to consume it.
const HANDOVER_PATHNAME = /\/checkout\/[^/]+\/redirect\/?$/

/**
 * The session that owns the order, handed over on the post-payment redirect.
 *
 * The redirect back from a payment provider can land in a different browser
 * than the one that started checkout - iOS gives the return URL to the default
 * browser, not the originating one - so the owning session's token travels in
 * the URL as `?hsat=` (see routes.checkout.redirect).
 *
 * Adopted by AccountProvider, which would otherwise bootstrap a guest session
 * on that route: that clears hg::cache::order and replaces the owner's token,
 * leaving the redirect unable to read its own order.
 *
 * Non-null only on the post-payment redirect.
 */
export const getHandoverAccessToken = () => {
  if (typeof window === "undefined") {
    return null
  }

  if (!HANDOVER_PATHNAME.test(window.location.pathname)) {
    return null
  }

  const searchParams = new URLSearchParams(window.location.search)

  return (
    searchParams.get(HANDOVER_ACCESS_TOKEN_PARAM) ??
    searchParams.get(LEGACY_ACCESS_TOKEN_PARAM)
  )
}
